export const usePageNumberParameter = (name: string) => {
  const route = useRoute()

  return computed(() => {
    const FIRST_PAGE = 1

    let page = FIRST_PAGE

    const parameterValue = route.query[name]

    try {
      if (typeof parameterValue === 'string') {
        page = parseInt(parameterValue, 10)
      }
    } catch {
      // Ignored
    }

    return isNaN(page) ? FIRST_PAGE : Math.max(page, FIRST_PAGE)
  })
}
